import { render } from "./serieCadastro.vue?vue&type=template&id=52766d30"
import script from "./serieCadastro.vue?vue&type=script&lang=js"
export * from "./serieCadastro.vue?vue&type=script&lang=js"

import "./serieCadastro.vue?vue&type=style&index=0&id=52766d30&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__